// 是否语音验证码
export const VOICE_CODE = {
  ENABLE: 1, // 开启
  DISABLE: 0 // 关闭
}

// 第三方登录渠道
export const THIRD_COMMON_LOGIN_APP_MAP = {
  mp_dongguantong: (from, cityId) => {
    return from === 'mp_dongguantong' && cityId === '008'
  }
}